export const validationConstants = {
  MIN_PASSWORD_LENGTH: 6,
  FIELD_IS_REQUIRED_TEXT: 'The field is required',
  INVALID_EMAIL_TEXT: 'Invalid email address',
  TOO_SHORT_PASSWORD: `Password is too short, use 6 characters or more`,
  PASSWORD_DO_NOT_MATCH: 'Passwords do not match',
}
